import appConfig from '../reducers/appConfig'
import {IAppStore} from '../interfaces/reducers'
import {IPaylodAction, IActionDispatcher} from '../interfaces/dispatchers'
import {
  IInputData,
  ILayerNames,
  IReadValidationData,
  IReadValidationSuccessData,
  IConnectValidationData,
  IConnectValidationSuccessData,
  IImportActionData
} from '../interfaces/reducers/IRegImport'
import {RegImportAction} from '../enums/ActionTypes/RegImportAction'
import Axios from 'axios'
import {appFeatureTablesDispatcher} from './appFeatureTablesDispatcher'
import {appSingleViewDispatcher} from './appSingleViewDispatcher'

export const updateInputData =
  (inputData: IInputData) =>
  (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
    dispatch({
      type: RegImportAction.UPDATE_IMPORT_DATA,
      payload: inputData
    })
  }

export const updateInputDataLayers =
  (inputData: ILayerNames) =>
  (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
    dispatch({
      type: RegImportAction.UPDATE_IMPORT_DATA_LAYERS,
      payload: inputData
    })
  }
const unError = 'Възникна грешка! Опитайте пак и или се обърнете към администратор'
export const validate =
  () => (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
    const inputData = getStore().regImport.inputData
    const formData = new FormData()
    formData.append('File', inputData.file!.file!, inputData.file!.name)

    const payload: {[key: string]: any} = {
      LocationId: inputData.location!.getProperties()['Id'],
      PlanDate: new Date(
        inputData.planDate.getFullYear(),
        inputData.planDate.getMonth(),
        inputData.planDate.getDate(),
        12
      ).toISOString(),
      ApprovedDate: inputData.approvedDate
        ? new Date(
            inputData.approvedDate.getFullYear(),
            inputData.approvedDate.getMonth(),
            inputData.approvedDate.getDate(),
            12
          ).toISOString()
        : undefined
      // TODO TODO TODO remove .toISOString()
    }

    const inputDataIndexed = inputData as unknown as Record<string, any>
    for (const key in inputDataIndexed) {
      if (key == 'layerNames') {
        const layerNames = inputDataIndexed[key] as Record<string, any>
        for (const k in layerNames) {
          payload[k] = layerNames[k]
        }
      } else if (typeof inputDataIndexed[key] != 'object') {
        payload[key] = inputDataIndexed[key]
      }
    }
    formData.append('RegImportInputData', JSON.stringify(payload))
    dispatch({
      type: RegImportAction.UPDATE_IMPORT_DATA,
      payload: {
        ...getStore().regImport.inputData,
        loading: true,
        errors: [],
        startedImportGuid: '',
        expanded: false
      } as IInputData
    })
    dispatch({
      type: RegImportAction.UPDATE_READ_VALIDATE_DATA,
      payload: {
        ...getStore().regImport.readValidationData,
        loading: false,
        errors: [],
        successData: undefined,
        exists: false
      } as IReadValidationData
    })
    dispatch({
      type: RegImportAction.UPDATE_CONNECT_VALIDATE_DATA,
      payload: {
        ...getStore().regImport.readValidationData,
        loading: false,
        errors: [],
        successData: undefined,
        exists: false
      } as IReadValidationData
    })
    dispatch({
      type: RegImportAction.UPDATE_IMPORT_ACTION_DATA,
      payload: {
        ...getStore().regImport.connectValidationData,
        loading: false,
        success: false,
        errors: []
      } as IImportActionData
    })
    Axios.post(`${appConfig.regimport.regimportUrl1}`, formData, {headers: {'Content-Type': `multipart/form-data;`}})
      .then(response => {
        if (response.data['PATH']) {
          dispatch({
            type: RegImportAction.UPDATE_IMPORT_DATA,
            payload: {...getStore().regImport.inputData, startedImportGuid: response.data['PATH']} as IInputData
          })
          dispatch(stage2(response.data['PATH']))
        } else {
          dispatch({
            type: RegImportAction.UPDATE_IMPORT_DATA,
            payload: {...getStore().regImport.inputData, loading: false, errors: response.data} as IInputData
          })
        }
      })
      .catch(e => {
        dispatch({
          type: RegImportAction.UPDATE_IMPORT_DATA,
          payload: {...getStore().regImport.inputData, loading: false, errors: [unError]}
        })
      })
  }
//read
let stage2int: ReturnType<typeof setInterval>
let stage3int: ReturnType<typeof setInterval>
let hardStage2ErrorTimeout: ReturnType<typeof setTimeout>
let hardStage3ErrorTimeout: ReturnType<typeof setTimeout>

const stage2 =
  (path: string) => (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
    dispatch({
      type: RegImportAction.UPDATE_READ_VALIDATE_DATA,
      payload: {...getStore().regImport.readValidationData, loading: true, exists: true} as IReadValidationData
    })
    let waiting = false
    stage2int = setInterval(() => {
      if (!waiting) {
        waiting = true
        Axios.get(appConfig.urls.xyApiUrl + '/RegImportFiles/' + path + '/stage2savedProgress.json')
          .then(r => {
            clearInterval(stage2int)
            if (hardStage2ErrorTimeout) {
              clearTimeout(hardStage2ErrorTimeout)
            }
            if (r.data.QuarterSegmentsUrl) {
              const data = r.data as IReadValidationSuccessData
              const successData: IReadValidationSuccessData = {
                ParcelsNumber: data.ParcelsNumber,
                QuarterNumbers: data.QuarterNumbers,

                QuarterSegmentsUrl: appConfig.urls.xyApiUrl + data.QuarterSegmentsUrl,
                QuartersUrl: appConfig.urls.xyApiUrl + data.QuartersUrl,
                ParcelSegmentsUrl: appConfig.urls.xyApiUrl + data.ParcelSegmentsUrl,
                ParcelsUrl: appConfig.urls.xyApiUrl + data.ParcelsUrl
              }
              dispatch({
                type: RegImportAction.UPDATE_READ_VALIDATE_DATA,
                payload: {
                  ...getStore().regImport.readValidationData,
                  loading: false,
                  errors: [],
                  successData: successData
                } as IReadValidationData
              })
              dispatch(stage3(path))
            } else {
              dispatch({
                type: RegImportAction.UPDATE_READ_VALIDATE_DATA,
                payload: {
                  ...getStore().regImport.readValidationData,
                  loading: false,
                  errors: [r.data]
                } as IReadValidationData
              })
              dispatch({
                type: RegImportAction.UPDATE_IMPORT_DATA,
                payload: {...getStore().regImport.inputData, loading: false} as IInputData
              })
            }
          })
          .catch(e => {
            waiting = false
            if (!e.response || e.response.status != 404) {
              clearInterval(stage2int)
              if (hardStage2ErrorTimeout) {
                clearTimeout(hardStage2ErrorTimeout)
              }
              dispatch({
                type: RegImportAction.UPDATE_READ_VALIDATE_DATA,
                payload: {
                  ...getStore().regImport.readValidationData,
                  loading: false,
                  errors: [unError]
                } as IReadValidationData
              })
              dispatch({
                type: RegImportAction.UPDATE_IMPORT_DATA,
                payload: {...getStore().regImport.inputData, loading: false} as IInputData
              })
            }
          })
      }
    }, 2000)
    hardStage2ErrorTimeout = setTimeout(() => {
      waiting = false
      clearInterval(stage2int)
      dispatch({
        type: RegImportAction.UPDATE_READ_VALIDATE_DATA,
        payload: {
          ...getStore().regImport.readValidationData,
          loading: false,
          errors: [unError]
        } as IReadValidationData
      })
      dispatch({
        type: RegImportAction.UPDATE_IMPORT_DATA,
        payload: {...getStore().regImport.inputData, loading: false} as IInputData
      })
    }, 60000 * 60)
  }
//connect
const stage3 =
  (path: string) => (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
    dispatch({
      type: RegImportAction.UPDATE_CONNECT_VALIDATE_DATA,
      payload: {...getStore().regImport.connectValidationData, loading: true, exists: true} as IConnectValidationData
    })
    let waiting = false
    stage3int = setInterval(() => {
      if (!waiting) {
        waiting = true
        Axios.get(appConfig.urls.xyApiUrl + '/RegImportFiles/' + path + '/stage3statusFile.json')
          .then(r => {
            if (r.data && r.data.SuccessDxf) {
              const data = r.data as IConnectValidationSuccessData
              data.SuccessDxf = appConfig.urls.xyApiUrl + data.SuccessDxf
              data.importPath = path
              clearInterval(stage3int)
              if (hardStage3ErrorTimeout) {
                clearTimeout(hardStage3ErrorTimeout)
              }
              dispatch({
                type: RegImportAction.UPDATE_CONNECT_VALIDATE_DATA,
                payload: {
                  ...getStore().regImport.connectValidationData,
                  loading: false,
                  errors: {messages: [], dxf: ''},
                  successData: data
                } as IConnectValidationData
              })
              dispatch({
                type: RegImportAction.UPDATE_IMPORT_DATA,
                payload: {...getStore().regImport.inputData, loading: false} as IInputData
              })
            } else {
              dispatch({
                type: RegImportAction.UPDATE_CONNECT_VALIDATE_DATA,
                payload: {
                  ...getStore().regImport.connectValidationData,
                  loading: false,
                  errors: {
                    messages: r.data.Errors || [unError],
                    dxf: r.data.ErrorsDxf
                      ? appConfig.regimport.regImportGetFileUrl + '/' + path + '/' + r.data.ErrorsDxf
                      : ''
                  }
                } as IConnectValidationData
              })
              dispatch({
                type: RegImportAction.UPDATE_IMPORT_DATA,
                payload: {...getStore().regImport.inputData, loading: false} as IInputData
              })
            }
          })
          .catch(e => {
            waiting = false
            if (!e.response || e.response.status != 404) {
              clearInterval(stage3int)
              if (hardStage3ErrorTimeout) {
                clearTimeout(hardStage3ErrorTimeout)
              }
              dispatch({
                type: RegImportAction.UPDATE_CONNECT_VALIDATE_DATA,
                payload: {
                  ...getStore().regImport.connectValidationData,
                  loading: false,
                  errors: {messages: [unError]}
                } as IConnectValidationData
              })
              dispatch({
                type: RegImportAction.UPDATE_IMPORT_DATA,
                payload: {...getStore().regImport.inputData, loading: false} as IInputData
              })
            }
          })
      }
    }, 2000)
    hardStage3ErrorTimeout = setTimeout(() => {
      waiting = false
      clearInterval(stage3int)
      dispatch({
        type: RegImportAction.UPDATE_CONNECT_VALIDATE_DATA,
        payload: {
          ...getStore().regImport.connectValidationData,
          loading: false,
          errors: {messages: [unError]}
        } as IConnectValidationData
      })
      dispatch({
        type: RegImportAction.UPDATE_IMPORT_DATA,
        payload: {...getStore().regImport.inputData, loading: false} as IInputData
      })
    }, 60000 * 60)
  }

export const importReg =
  (path: string) => (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
    dispatch({
      type: RegImportAction.UPDATE_IMPORT_ACTION_DATA,
      payload: {...getStore().regImport.connectValidationData, loading: true}
    })
    dispatch({
      type: RegImportAction.UPDATE_IMPORT_DATA,
      payload: {...getStore().regImport.inputData, loading: true} as IInputData
    })
    Axios.get(appConfig.regimport.importReg + '/' + path)
      .then(() => {
        for (const id in getStore().layerInfos.featureLayerInfos) {
          getStore().layerInfos.featureLayerInfos[id].refresh()
        }
        const featureIds = Object.keys(getStore().data.featureTables)
        dispatch(appFeatureTablesDispatcher.setTablesVisibility({}))
        if (featureIds.length > 0) {
          dispatch(appFeatureTablesDispatcher.refrashTable(featureIds[0]))
        }
        dispatch({
          type: RegImportAction.UPDATE_IMPORT_ACTION_DATA,
          payload: {
            ...getStore().regImport.connectValidationData,
            loading: false,
            success: true,
            errors: []
          } as IImportActionData
        })
        dispatch({
          type: RegImportAction.UPDATE_IMPORT_DATA,
          payload: {...getStore().regImport.inputData, loading: false} as IInputData
        })
        dispatch(appSingleViewDispatcher.removeSelection())
      })
      .catch(e => {
        dispatch({
          type: RegImportAction.UPDATE_IMPORT_ACTION_DATA,
          payload: {
            ...getStore().regImport.connectValidationData,
            loading: false,
            errors: [unError],
            success: false
          } as IImportActionData
        })
        dispatch({
          type: RegImportAction.UPDATE_IMPORT_DATA,
          payload: {...getStore().regImport.inputData, loading: false} as IInputData
        })
      })
  }
